// terrainNavLinks construye el arreglo de tabs (TabNav.vue) compartido por
// las 5 vistas de nivel superior de Terreno, gateado por capacidad —
// factorizado en un solo lugar (a diferencia del patrón de Monitoreo, que
// duplica el array por vista) porque acá SÍ hay lógica de permisos, no solo
// un arreglo estático: duplicarla 5 veces arriesga que una futura regla de
// acceso quede desincronizada entre vistas.
export function terrainNavLinks(permissions) {
  const terrain = permissions || {};
  const links = [];
  if (terrain.manage) {
    links.push({ name: "Campañas", path: "/terreno/campanas" });
    links.push({ name: "Plantillas", path: "/terreno/plantillas" });
    links.push({ name: "Cuadrillas", path: "/terreno/cuadrillas" });
  }
  if (terrain.manage || terrain.review) {
    links.push({ name: "Revisión", path: "/terreno/revision" });
  }
  return links;
}
